export enum Direction {
    Up,
    Right,
    Down,
    Left
}


// WEBPACK FOOTER //
// ./src/game/util/direction.ts